export default __webpack_public_path__ + "static/media/arrow-right-circle.f9dec97b.svg";